import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SharedService } from 'src/app/core/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { MailConfigurationComponent } from '../mail-configuration/mail-configuration.component';

@Component({
  selector: 'app-mail-list',
  templateUrl: './mail-list.component.html',
  styleUrls: ['./mail-list.component.scss']
})
export class MailListComponent implements OnInit {

  @Output() newItemEvent = new EventEmitter<string>();
  @Output() mailDetailsEvent = new EventEmitter<any>();
  @Output() refreshMail = new EventEmitter<string>();
  @Output() closeMailBox = new EventEmitter<any>();
  @Input() claimIdInput: any;

  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;

  ngOnChanges(changes: SimpleChanges) {
    this.setClaimId(changes.claimIdInput.currentValue);
  }

  constructor(
    private sharedService: SharedService,
    public dialog: MatDialog
  ) { }

  mailSearch: FormControl = new FormControl(null);

  mails: Array<any> = [];
  mailsBackup: Array<any> = [];
  mailCount: any;
  totalMailCount: any;
  claimId: any;
  allowActions = false;
  documentBucket: Array<any> = [];
  isMailConfigured = false;
  mailConfigType: any;
  isMailLoading = false;
  pageIndex: any;
  claimDetails: any;

  ngOnInit(): void {
    if (localStorage.getItem('mailPage')) {
      this.fetchMails(localStorage.getItem('mailPage'), 10);
      this.pageIndex = localStorage.getItem('mailPage');
    } else {
      this.fetchMails(0, 10);
    }
  }

  mailPagination(event: any) {
    this.fetchMails(event.pageIndex, event.pageSize);
    localStorage.setItem('mailPage', event.pageIndex);
  }

  refresh() {
    this.fetchMails(0, 10);
    this.paginator?.firstPage();
  }

  setClaimId(details: any) {
    if(details) {
      this.claimId = details.claimId.replace(/[_]/g, '/');
      this.claimDetails = details;
      this.allowActions = true;
    } else {
      this.allowActions = false;
    }
  }

  addNewItem(value: any) {
    this.newItemEvent.emit(value);
  }

  addMailDetails(value: any) {
    this.mailDetailsEvent.emit(value);
  }

  closeMail() {
    this.closeMailBox.emit('false');
    localStorage.removeItem('mailId');
    localStorage.removeItem('mailPage');
    this.pageIndex = 0;
    localStorage.setItem('sidenav', 'false');
  }

  applyFilter(event: Event) {
    this.mails = this.mailsBackup;
    const filterValue = (event.target as HTMLInputElement).value;
    let mailsObj = this.mails.filter((mail) => mail?.subject?.trim().toLowerCase().includes(filterValue.trim().toLowerCase()) || mail?.from?.split("<")[0].trim().toLowerCase().includes(filterValue.trim().toLowerCase()));
    this.mails = mailsObj;
  }

  selectConfigType(type: any) {
    this.mailConfigType = type;

    if (this.mailConfigType === 'outlook') {
      this.mailConfiguration(type);
    }

    if (this.mailConfigType === 'other') {
      this.mailConfiguration(type);
    }
  }

  fetchMails(pageIndex: any, pageSize: any) {
    this.isMailLoading = true;
    this.sharedService.fetchMailbox(pageIndex, pageSize).subscribe(
      (res: any) => {
        if (res.status === 201) {
          this.isMailLoading = false;
          Swal.fire('', res.message, 'error');
          Swal.fire('', 'Please configure mailbox before accessing mails', 'info');
          this.isMailConfigured = false;
        } else {
          this.isMailConfigured = true;
          this.isMailLoading = false;
          this.mails = res.body?.maildetails;
          this.totalMailCount = res.body?.totalMail;
          if (localStorage.getItem('mailId')) {
            let mailId = localStorage.getItem('mailId');
            for (let mail of this.mails) {
              if (mail.id === mailId) {
                this.openMail(mail);
              }
            }
          }
          this.mailsBackup = res.body;
          this.mailCount = res.body?.length;

        }
      },
      (err: any) => {
        this.isMailLoading = false;
        this.pageIndex = 0;
        Swal.fire('', 'Failed to fetch mails successfully', 'error');
      }
    );
  }

  mailConfiguration(configType: any) {
    const dialogRef = this.dialog.open(MailConfigurationComponent, {
      width: '80vw',
      data: { configType: configType }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'success') {
        this.isMailConfigured = true;
        this.isMailLoading = true;
        setTimeout(() => {
          this.fetchMails(0, 10);
        }, 20000);
      }
    });
  }

  openMail(mail: any) {
    localStorage.setItem('mailId', mail.id);
    this.addNewItem('details');
    this.addMailDetails(mail);
  }

  checkMode(mode: any, mail: any) {
    if (mode === 'attachMail') {
      this.attachMail(mode, mail);
    }
    else if (mode === 'attachDoc') {
      this.documentBucket = [];
      for (let mailDoc of mail.attechments) {
        let docObj = {
          documentType: "Other Document",
          attachmentId: mailDoc.attechmentId
        }
        this.documentBucket.push(docObj);
      }
      if (this.documentBucket.length === 0) {
        Swal.fire('', 'No documents present in mail', 'warning');
      } else {
        this.attachMail(mode, mail);
      }
    }
  }

  refreshClaim(value: any) {
    this.refreshMail.emit(value);
  }

  attachMail(mode: any, mail: any) {
    Swal.showLoading();
    let submitData: any;
    if (mode === 'attachMail') {
      submitData = {
        claimId: this.claimId,
        messageId: mail.id,
      }
    } else if (mode === 'attachDoc') {
      submitData = {
        claimId: this.claimId,
        messageId: mail.id,
        documents: this.documentBucket
      }
    }
    //Creating final SubmitData object 
    this.sharedService.attachMailToClaim(submitData).subscribe(
      (res: any) => {
        this.refreshClaim('refresh');
        Swal.close();
        Swal.fire('', 'Mail Attached Successfully', 'success');
        this.refreshClaim('refresh');
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }

}
